import { render, staticRenderFns } from "./eventTab.vue?vue&type=template&id=7212c560&lang=pug"
import script from "./eventTab.vue?vue&type=script&lang=js"
export * from "./eventTab.vue?vue&type=script&lang=js"
import style0 from "./eventTab.vue?vue&type=style&index=0&id=7212c560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports